import pointlessMd from './pointless.md'
import pointlessImg from './pointless.png'

import labradarMd from './labradar.md'
import labradarImg from './labradar.jpg'

import imbalanceMd from './imbalance.md'
import imbalanceImg from './imbalance.png'

const posts = [
  {
    title: 'Bullet Imbalance: The silent killer of the perfect shot',
    tag: 'bullet-imbalance',
    date: 'Feb 2, 2024',
    description: 'In the first entry in our series on shooting science we talk about bullet imbalance and how it effects precision and dispersion.',
    markdown: imbalanceMd,
    image: imbalanceImg,
    imageLabel: 'Bullet Imbalance'
  },
  {
    title: 'How to calculate BC with a Labradar',
    tag: 'labradar-bc-how-to',
    date: 'July 1, 2023',
    description: 'Can you calculate ballistic coefficients with a Labradar? It turns out you can with a little know how.',
    markdown: labradarMd,
    image: labradarImg,
    imageLabel: 'Labradar'
  },
  {
    title: 'The Myth of Five-Shot Groups and the Science of Precision Shooting',
    tag: 'five-shot-groups-are-pointless',
    date: 'May 28, 2023',
    description: 'Why don\'t bullets go through the same hole every time? It\'s complicated, but it turns out that 5-shot groups are a terrible way to figure it out, and science agrees.',
    markdown: pointlessMd,
    image: pointlessImg,
    imageLabel: 'Five shot groups are pointless'
  },
]

export default posts
